import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { MasterHoldChargeInfoEntity } from "domain/entity/MasterHold/MasterHoldChargeInfoEntity";
import { EMPTY_MASTER_HOLD_ENTITY, MasterHoldEntity } from "domain/entity/MasterHold/MasterHoldEntity";
import { ChargeTypeRepository } from "domain/repository/ChargeType/ChargeTypeRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { MasterHoldRepository } from "domain/repository/MasterHold/MasterHoldRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import { SpecialHandlingIndMappingRepository } from "domain/repository/SpecialHanldingInd/SpecialHandlingIndMappingRepo";
import { StandardTariffCodeRepository } from "domain/repository/TariffCode/StandardTariffCodeRepo";
import { TariffTypeRepository } from "domain/repository/TariffCode/TariffTypeRepo";
import _ from "lodash";
import { MasterHoldTargetDroOpts } from "presentation/constant/DropDownOptions/Document/MasterHoldTargetDroOpts";
import { MasterHoldMaintenanceValidationSchema } from "presentation/constant/MasterHold/MasterHoldMaintenanceValidationSchema";
import { ParameterCodeValue } from "presentation/constant/Parameter/ParameterCodeValue";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { MasterHoldMaintenanceModel } from "presentation/model/MasterHold/MasterHoldMaintenanceModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface MasterHoldMaintenanceVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<MasterHoldMaintenanceModel>> | ((value: SetStateAction<MasterHoldMaintenanceModel>) => void),
    ],
    repo: MasterHoldRepository,
    companyRepo: CompanyRepository,
    chargeTypeRepo: ChargeTypeRepository,
    standardTariffCodeRepo: StandardTariffCodeRepository,
    parameterDetailRepo: ParameterDetailRepository,
    tariffTypeRepo: TariffTypeRepository,
    specialhandlingIndMappingRepo: SpecialHandlingIndMappingRepository,
}

export const MasterHoldMaintenanceVM = ({ dispatch, repo, companyRepo, chargeTypeRepo, standardTariffCodeRepo, parameterDetailRepo, tariffTypeRepo, specialhandlingIndMappingRepo }: MasterHoldMaintenanceVMProps) => {
    const [masterHoldMainDispatch] = dispatch;

    const onShowLoading = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }

    const updateSelectedRows = async (rows: MasterHoldEntity[]) => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                //tableData: [...allRows],
                selectedRows: rows,
            }
        })
    }

    const onApply = async (rows: MasterHoldEntity[]) => {
        return await repo.applyEntity(rows);
    }

    const updateSelectedChgInfoRows = async (allRows: MasterHoldChargeInfoEntity[], rows: MasterHoldChargeInfoEntity[]) => {

        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    // masterHoldChgInfoList: [...allRows],
                    selectedRows: rows
                }
            }
        })
    }

    const onRowDoubleClick = (entity: MasterHoldEntity) => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowCriteriaPanel: false,
                isShowDetail: true,
                currentSelectedRow: entity,

                masterState: {
                    ...prevState.masterState,
                    isTabularDataActive: false,
                    isAdd: false,
                    isRead: true,
                    isEditable: true,
                    isSaveClicked: false,
                    isSliderOpen: true,
                    allFormState: {}
                },
                detailState: {
                    ...prevState.detailState,
                    isTabularDataActive: false,
                    isAdd: false,
                    isRead: true,
                    isEditable: false,
                    isSliderOpen: false,
                    isSelected: false,
                    allFormState: {}
                }
            }
        })
    }

    const loadDropdownOption = async () => {

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let masterCompanies = companies?.filter(company => company.companyType === 'MASTER');

                let masterCompanyDropdownOptions = masterCompanies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.id.toString(),
                    value: company.companyCode,
                })) ?? []
                masterCompanyDropdownOptions = _.orderBy(masterCompanyDropdownOptions, "dropdownLabel");

                let comCompanies = companies?.filter(company => company.companyType !== 'MASTER' && company.companyType !== 'ALLIANCE');

                let companyDropdownOptions = comCompanies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.id.toString(),
                    value: company.companyCode,
                })) ?? []
                companyDropdownOptions = _.orderBy(companyDropdownOptions, "dropdownLabel");

                let opsLineCompanies = companies?.filter(company => company.customerType === 'SL' && company.status === "CONFIRMED" && company.activeInd === 'Y');
                let opsLineDropdownOptions = opsLineCompanies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.id.toString(),
                    value: company.companyCode,
                })) ?? []
                opsLineDropdownOptions = _.orderBy(opsLineDropdownOptions, "dropdownLabel");

                masterHoldMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        masterCompanyCodeDropdownOptions: masterCompanyDropdownOptions,
                        companyCodeDropdownOptions: companyDropdownOptions,
                        opsLineDropdownOptions: opsLineDropdownOptions
                    }
                }))
            }
        );

        await chargeTypeRepo.getAllChargeTypesForCombobox().then(
            chargeTypes => {
                let newChargeTypes = _.orderBy(chargeTypes, ["chargeType", "subChargeType"]);
                let chargeTypeDropdownOptions: DropdownProps[] = [];
                let subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] } = {};
                newChargeTypes?.forEach(chgTypeEty => {
                    const chgTypeExisted = chargeTypeDropdownOptions?.find(chgType =>
                        chgType.value === chgTypeEty.chargeType);
                    if (!chgTypeExisted) {
                        chargeTypeDropdownOptions.push({
                            dropdownLabel: chgTypeEty.chargeType,
                            tagLabel: chgTypeEty.chargeType,
                            value: chgTypeEty.chargeType
                        })
                    }

                    if (chgTypeEty.subChargeType) {
                        if (!subChargeTypeDropdownOptions[chgTypeEty.chargeType]) {
                            subChargeTypeDropdownOptions[chgTypeEty.chargeType] = [];
                        }
                        subChargeTypeDropdownOptions[chgTypeEty.chargeType].push({
                            dropdownLabel: chgTypeEty.subChargeType,
                            tagLabel: chgTypeEty.subChargeType,
                            value: chgTypeEty.subChargeType
                        });
                    }
                });

                masterHoldMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        chargeTypeDropdownOptions: chargeTypeDropdownOptions,
                        subChargeTypeDropdownOptions: subChargeTypeDropdownOptions
                    }
                }))
            }
        )

        await tariffTypeRepo.getAllActiveTariffTypes().then(
            tariffs => {
                let newTariffs = _.orderBy(tariffs, ["tariffType"]);
                let tariffTypeDropdownOption = newTariffs?.map((tariff) => ({
                    dropdownLabel: tariff.tariffType,
                    tagLabel: tariff.tariffType,
                    value: tariff.tariffType,
                })) ?? []
                masterHoldMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        tariffTypeDropdownOptions: tariffTypeDropdownOption,
                    }
                }))
            }
        );

        await standardTariffCodeRepo.getAllStandardTariffCodes().then(
            tariffs => {

                let newTariffs = _.orderBy(tariffs, ["tariffType", "tariffCode"]);
                let tariffCodeDropdownOptions: { [key: string]: DropdownProps[] } = {};

                newTariffs?.forEach(tariff => {

                    if (tariff.tariffCode) {
                        if (!tariffCodeDropdownOptions[tariff.tariffType]) {
                            tariffCodeDropdownOptions[tariff.tariffType] = [];
                        }
                        tariffCodeDropdownOptions[tariff.tariffType].push({
                            dropdownLabel: tariff.tariffCode,
                            tagLabel: tariff.tariffCode,
                            value: tariff.tariffCode,
                        })

                    }
                })

                masterHoldMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        tariffCodeDropdownOptions: tariffCodeDropdownOptions,
                    }
                }))
            }
        )

        await parameterDetailRepo.getAllParameterDtlsByParameterCode(ParameterCodeValue.SHIPMENT_TYPE).then(
            shipmentTypes => {
                const shipmentTypeDropdownOptions = shipmentTypes?.map((shipmentType) => ({
                    dropdownLabel: shipmentType.parameterDtlCode,
                    tagLabel: shipmentType.parameterDtlCode,
                    value: shipmentType.parameterDtlCode,
                })) ?? []

                masterHoldMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        shipmentTypeDropdownOptions: shipmentTypeDropdownOptions,
                    }
                }))
            }
        )

        await specialhandlingIndMappingRepo.getAllSpecialHandlingIndMappings().then(
            specialHandlingIndList => {
                const specialHandlingindDropdownOption = specialHandlingIndList?.map((specialHandlingInd) => ({
                    dropdownLabel: specialHandlingInd.specialHandlingInd,
                    tagLabel: specialHandlingInd.specialHandlingInd,
                    value: specialHandlingInd.specialHandlingInd,
                })) ?? []

                masterHoldMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        specHandingIndDropdownOptions: specialHandlingindDropdownOption,
                    }
                }))
            }
        )

        masterHoldMainDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                targetStateDropdownOptions: MasterHoldTargetDroOpts().getTargetModel()
            }
        }))
    }

    const onInitDefaultValue = async () => {
    }

    const searchMasterHold = async () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                tableData: [],
                selectedRows: [],
                isShowDeleteModal: false,
            }
        })
        await repo.getEntities().then((data) => {
            masterHoldMainDispatch(prevState => {
                return {
                    ...prevState,
                    tableData: data,
                    selectedRows: [],
                    currentSelectedRow: EMPTY_MASTER_HOLD_ENTITY,
                    isBackMaster: false,
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const searchChargeInfo = async (masterHoldId: number) => {
        await repo.searchChargeInfo(masterHoldId).then((data) => {
            return masterHoldMainDispatch(prevState => ({
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    masterHoldChgInfoList: data
                }
            }))
        }).catch((error) => {
            return [];
        })
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }


        masterHoldMainDispatch(prevState => {
            let tariffCode = prevState.masterState.editingEntity.tariffCode;
            let subChargeType = prevState.masterState.editingEntity.subChargeType;
            if (fieldKey === 'tariffType') {
                tariffCode = null;
            } else if (fieldKey === 'tariffCode') {
                tariffCode = val;
            }
            if (fieldKey === 'chargeType') {
                subChargeType = null;
            } else if (fieldKey === 'subChargeType') {
                subChargeType = val;
            }

            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingEntity: {
                        ...prevState.masterState.editingEntity,
                        [fieldKey]: val,
                        tariffCode: tariffCode,
                        subChargeType: subChargeType,
                    },
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: '',
                    }
                }
            }
        });
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        masterHoldMainDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                editingEntity: {
                    ...prevState.masterState.editingEntity,
                    [fieldName]: checked ? "Y" : "N"
                }
            }
        }))
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        masterHoldMainDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                editingEntity: {
                    ...prevState.masterState.editingEntity,
                    [dateFields.startField]: startDate,
                    [dateFields.endField]: endDate
                }
            }
        }))
    }

    const onResetClick = async () => {
        masterHoldMainDispatch(prevState => {
            let tempMasterHoldEty: MasterHoldEntity = EMPTY_MASTER_HOLD_ENTITY;
            if (!prevState.masterState.isAdd) {
                tempMasterHoldEty = prevState.currentSelectedRow
            }

            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingEntity: {
                        ...tempMasterHoldEty,
                    },
                }
            }
        })
    }

    const onAddClick = () => {
        masterHoldMainDispatch(prevState => ({
            ...prevState,
            //isShowDetail: true,
            currentSelectedRow: EMPTY_MASTER_HOLD_ENTITY,
            masterState: {
                ...prevState.masterState,
                isTabularDataActive: false,
                isAdd: true,
                isRead: false,
                isEditable: false,
                isSaveClicked: false,
                isSliderOpen: true,
                allFormState: {},
                editingEntity: {
                    ...EMPTY_MASTER_HOLD_ENTITY,
                    target: prevState.dynamicOptions.targetStateDropdownOptions[0].value
                },
            },
            detailState: {
                ...prevState.detailState,
                isTabularDataActive: false,
                isAdd: false,
                isRead: true,
                isEditable: false,
                isSliderOpen: false,
                isSelected: false,
                allFormState: {}
            }
        }))
    };

    const onDeleteClick = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowDeleteModal: true
            }
        });
    }

    const onDelete = async (selectedRows: MasterHoldEntity[]) => {
        return await repo.deleteEntity(selectedRows);
        /* 
         .then((res) => {
             masterHoldMainDispatch(prevState => {
                 return {
                     ...prevState,
                     isShowRightPanel: false,
                     currentSelectedRow: EMPTY_MASTER_HOLD_ENTITY,
                     selectedRows: [],
                     isShowDeleteModal: false,
 
                     masterState: {
                         isSliderOpen: false,
                         isTabularDataActive: false,
                         isAdd: false,
                         isRead: false,
                         isEditable: false,
                         isSaveClicked: false,
                         lastEditRowId: "",
                         isSelected: false,
                         slider: {
                             isAdd: false,
                             isRead: false,
                             isEditable: false
                         },
                         editingEntity: EMPTY_MASTER_HOLD_ENTITY
                     }
                 }
             });
         })
             */
    }

    const onRelease = async (selectedRows: MasterHoldChargeInfoEntity[]) => {
        /*await repo.releaseChargeInfo(selectedRows).then((res) => {
            masterHoldMainDispatch(prevState => {
                return {
                    ...prevState,                    
                    detailState: {
                        ...prevState.detailState,
                        masterHoldChgInfoList: [],                        
                        selectedRows: []
                    }
                }
            });
        })    */

        return await repo.releaseChargeInfo(selectedRows);

    }

    const onHold = async (selectedRows: MasterHoldChargeInfoEntity[]) => {
        /*await repo.holdChargeInfo(selectedRows).then((res) => {
            masterHoldMainDispatch(prevState => {
                return {
                    ...prevState,                    
                    detailState: {
                        ...prevState.detailState, 
                        masterHoldChgInfoList: [],                      
                        selectedRows: []
                    }
                }
            });
        }) */
        return await repo.holdChargeInfo(selectedRows);
    }

    const onCancelDelete = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowDeleteModal: false
            }
        });
    }

    const onSave = async (currentMasterHoldEty: MasterHoldEntity, isAdd: boolean) => {
        const valHdrResult = await Validation(MasterHoldMaintenanceValidationSchema).ValidateFormOnly(currentMasterHoldEty);

        if (valHdrResult) {
            let validatedResult: { [x: string]: string } = {};
            if (valHdrResult) {
                validatedResult = { ...validatedResult, ...valHdrResult, /*mandatoryCheckFail: 'Please input the missing value.'*/ };
            }

            masterHoldMainDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },

                    }
                }
            });
            // return validatedResult;
            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        } else {

            // let res = null;
            if (isAdd) {
                return await repo.createEntity(currentMasterHoldEty);
            } else {
                return await repo.updateEntity(currentMasterHoldEty);
            }

            // if (res.success) {
            //     // onCloseClick();
            //     return { success: true };
            // } else {
            //     return { error: res.data };
            // }
        }
    }

    const onCloseClick = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowDetail: false,
                isBackMaster: true,
                selectedRows: [],
                currentSelectedRow: { ...EMPTY_MASTER_HOLD_ENTITY },
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    isTabularDataActive: true,
                    editingEntity: EMPTY_MASTER_HOLD_ENTITY,
                },
                detailState: {
                    ...prevState.detailState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    isTabularDataActive: true,
                    masterHoldChgInfoList: [],
                    selectedRows: []
                }
            }
        });
    }

    const onCloseEdit = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowDetail: true,
                isBackMaster: false,
                // selectedRows: [],
                // currentSelectedRow: { ...EMPTY_MASTER_HOLD_ENTITY },
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: true,
                    isRead: true,
                    isTabularDataActive: false,
                    // editingEntity: EMPTY_MASTER_HOLD_ENTITY,
                },
                detailState: {
                    ...prevState.detailState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    isTabularDataActive: false,
                    // masterHoldChgInfoList: [],
                    // selectedRows: []
                }
            }
        });
    }

    const onSaveClicked = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowSaveModal: prevState.masterState.isAdd ? false : true,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }


    const onEdit = (currentMasterHoldEty: MasterHoldEntity) => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isRead: false,
                    isEditable: true,

                    editingEntity: {
                        ...currentMasterHoldEty,
                    }
                },
            }
        })
    }

    const onPromptBoxYesClick = async (currentMasterHoldEty: MasterHoldEntity) => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowSaveModal: false
            }
        });

        let res = await repo.updateReleaseCntrEntity(currentMasterHoldEty);

        if (res.success) {
            return { success: true };
        } else {
            return { error: res.data };
        }
    }

    const onPromptBoxNoClick = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowSaveModal: false
            }
        });
    }

    const onPromptBoxCancelClick = () => {
        masterHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowSaveModal: false
            }
        });
    }


    return {
        loadDropdownOption: loadDropdownOption,
        onShowLoading: onShowLoading,
        onHideLoading: onHideLoading,
        onRowDoubleClick: onRowDoubleClick,
        onFieldChange: onFieldChange,
        searchMasterHold: searchMasterHold,
        searchChargeInfo: searchChargeInfo,
        updateSelectedRows: updateSelectedRows,
        updateSelectedChgInfoRows: updateSelectedChgInfoRows,
        onAddClick: onAddClick,
        onResetClick: onResetClick,
        onSave: onSave,
        onCloseClick: onCloseClick,
        onSaveClicked: onSaveClicked,
        onDeleteClick: onDeleteClick,
        onCancelDelete: onCancelDelete,
        onDelete: onDelete,
        onEdit: onEdit,
        onInitDefaultValue: onInitDefaultValue,
        onCheckboxChange: onCheckboxChange,
        onDateRangeChange: onDateRangeChange,
        onHold: onHold,
        onRelease: onRelease,
        onApply: onApply,
        onPromptBoxYesClick: onPromptBoxYesClick,
        onPromptBoxNoClick: onPromptBoxNoClick,
        onPromptBoxCancelClick: onPromptBoxCancelClick,
        onCloseEdit: onCloseEdit,
    }
}